import React, { useEffect } from "react";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";
import styled from "styled-components";

import {
  Button,
  StyledText,
  MainHolder,
  Children,
  Body,
  CircleContainer,
  DynamicButton,
} from "../../../components/common/basic";
import {
  AlertModal,
  BackButton,
  FeatureHeader,
} from "../../../components/common";
import usePotbelly from "./hooks/usePotbelly";
import MashupNowButton from "../mashupnwin/components/MashupNowButton";
const now = new Date().getTime();
const PotbellyHome = () => {
  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "PotbellyCodeGeneration",
        firebase_screen_class: "PotbellyCodeGeneration",
      })
    );
  }, []);

  const {
    background,
    history,
    bannerImage,
    offerDescription,
    steps,
    potbellyCode,
    reservePotbellyCode,
    potbellyStatus,
    isProcessingPotbelly,
    potbellyCodeGenerationMessage,
    showAlert,
    hideAlert,
  } = usePotbelly();
  const styles = generateStyles();

  return (
    <>
      <MainHolder>
        <Children>
          <BackButton
            onClick={() =>
              history.push(
                "/home?token=" + JSON.parse(localStorage.getItem("token"))
              )
            }
          />
          <FeatureHeader
            image={bannerImage}
            title={["Get your Potbelly", "with discounts"]}
            onClick={() => history.push("pulsenchill/points")}
            background={"#fff"}
            description={offerDescription}
            secondaryBackground={"#fff"}
          ></FeatureHeader>

          <Body>
            {
              // TODO: Update success property
              showAlert && (
                <AlertModal
                  background={background}
                  success={potbellyCodeGenerationMessage?.success}
                >
                  <div style={{ maxWidth: "280px", margin: "0 auto" }}>
                    <StyledText size={24}>Congrats</StyledText>
                    <StyledText
                      size={13}
                      style={{
                        fontFamily: "MTNRegular",
                        lineHeight: "140%",
                        marginBottom: "40px",
                      }}
                    >
                      You have redeem your Potbelly loyalty code{" "}
                      <span
                        style={{ color: background, fontFamily: "MTNMedium" }}
                      >
                        {potbellyCode}
                      </span>{" "}
                      to be presented to receive your Potbelly item . TCs apply.
                    </StyledText>
                    <DynamicButton
                      onClick={hideAlert}
                      label={
                        potbellyCodeGenerationMessage?.success ? "Great!" : "Ok"
                      }
                      disabled={false}
                      color={background}
                      fullWidth
                    />
                  </div>
                </AlertModal>
              )
            }

            <div style={{ boxSizing: "border-box", padding: "0 15px" }}>
              {potbellyCode ? (
                <CodeViewer background={background} Code={potbellyCode} />
              ) : (
                <GenerateButton
                  onClick={reservePotbellyCode}
                  loading={isProcessingPotbelly || potbellyStatus === null}
                  background={background}
                />
              )}

              <ContentHolder>
                <StyledText
                  size={18}
                  style={{ marginBottom: "10px" }}
                  fontFamily={"bold"}
                >{`How to Redeem your loyalty`}</StyledText>
                {steps?.map((item, index) => {
                  return (
                    <DescriptionItems
                      key={index}
                      style={{ marginBottom: "5px" }}
                    >
                      <CircleContainer>
                        <ColorCircle
                          color={background}
                          style={{ marginRight: "5px" }}
                        />
                      </CircleContainer>
                      <StyledText size={14} style={styles.textStyle}>
                        {item}
                      </StyledText>
                    </DescriptionItems>
                  );
                })}
              </ContentHolder>
            </div>
          </Body>
        </Children>
        <MashupButtonContainer>
          <MashupNowButton />
        </MashupButtonContainer>
      </MainHolder>
    </>
  );
};

const GenerateButton = ({ background, onClick, loading }) => (
  <Button
    style={{
      display: "flex",
      maxWidth: "200px",
      cursor: "pointer",
      justifyContent: "center",
      alignItems: "center",
      marginInline: 15,
      margin: "15px auto 25px auto",
    }}
    disabled={loading}
    color={background}
    onClick={() => {
      if (!loading) onClick();
    }}
  >
    <StyledText style={{ margin: 10 }} color={"white"}>
      {loading ? "Processing..." : "Generate code"}
    </StyledText>
  </Button>
);
const CodeViewer = ({ background, Code }) => (
  <>
    <StyledText
      size={14}
      style={{
        marginBlockStart: 0,
        marginBlockEnd: 0,
        padding: 2,
        textAlign: "center",
        width: "100%",
        // fontFamily: "MTNRegular",
        marginTop: 20,
      }}
    >
      {"Your Discount Code:"}
    </StyledText>
    <StyledText
      size={24}
      style={{
        marginBlockStart: 0,
        marginBlockEnd: 0,
        padding: 2,
        textAlign: "center",
        width: "100%",
        // fontFamily: "MTNRegular",
        color: background,
      }}
    >
      {Code}
    </StyledText>
  </>
);

const ContentHolder = styled.div`
  margin-inline: 20px;
`;

const DescriptionItems = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

const ColorCircle = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: ${({ color }) => color};
  margin-right: 10px;
`;

const generateStyles = () => {
  return {
    textStyle: {
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
  };
};

export default PotbellyHome;

const MashupButtonContainer = styled.div`
  width: 100%;
  padding-top: 20px;
  margin-bottom: 40px;
`;
